import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {
  goToPage,
  showPackageDetails,
  setUserSubscriberIndex,
  setUserCurrentSubscription,
  reportAnalytics,
} from '../PremiumPackagesHolder/PremiumPackagesHolderSlice';

const userPackages = (props) => {
  const [isShowUserPackages, setShowUserPackages] = useState(false);

  useEffect(() => {
    //TODO:DELETE
    if (props.socList != null) {
      createUserPackagesList();
    }
  }, [props.socList]);

  const toggleShowUserPackages = (props) => {
    isShowUserPackages ? setShowUserPackages(false) : setShowUserPackages(true);
  };

  const showUserDetailsHandler = (data) => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_5',
      eventLabel: data.name,
    });
    props.goToPage('packageDetails');
    props.setUserSubscriberIndex(data.userSubscriberIndex);
    props.setUserCurrentSubscription(true);
    props.showPackageDetails({show: true, index: data.packIndex, userPackageIndex: data.userPackageIndex});
  };

  const showUserPackages = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_4',
      eventLabel: 'element_6',
    });
    return (
      <div className='package-info-holder'>
        {props.packages != null
          ? props.packages.map(function (item, index) {
              return (
                <div
                  key={index}
                  className='package-info-container'
                  onClick={() =>
                    showUserDetailsHandler({
                      userPackageIndex: index,
                      packIndex: item.packIndex,
                      userSubscriberIndex: item.subscriptionIndex,
                      name: item.name,
                    })
                  }>
                  <div className='package-id'>{index + 1}.</div>
                  <div className='package-info'>
                    <p className='package-name'>{item.name}</p>
                    <div className='package-info-description'>
                      <p>{item.socTitle}</p>
                      {item.expired ? (
                        <p>
                          מסתיים ב-{' '}
                          {(item.expired.slice(0, 4) + '.' + item.expired.slice(4, 6) + '.' + item.expired.slice(6, 8))
                            .split('.')
                            .reverse()
                            .join('.')}
                        </p>
                      ) : (
                        <p>מנוי חודשי</p>
                      )}
                    </div>
                  </div>
                  <Image className='select-package-img' src={require('../images/select_sub.svg')} alt='חץ-בחירה' />
                </div>
              );
            })
          : null}
      </div>
    );
  };

  return (
    <section className='user-packages'>
      <div className={`${isShowUserPackages ? 'expand' : 'roll-up'} user-packages-selector`} onClick={() => toggleShowUserPackages()}>
        <div className={`${isShowUserPackages ? 'packages-count-expand' : null} packages-count`}>{props.packages.length}</div>
        <span className='user-packages-placeholder'>חבילות שכבר יש לכם</span>
        <Image className={isShowUserPackages ? 'arrow-toggle-up' : 'arrow-toggle-down'}
          src={require('../images/icons-back.svg')}
          alt='חץ' />
      </div>
      {isShowUserPackages ? showUserPackages() : null}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {goToPage, showPackageDetails, setUserSubscriberIndex, setUserCurrentSubscription, reportAnalytics};

export default connect(mapStateToProps, mapDispatchToProps)(userPackages);
